import React, { useState } from 'react';
import "./App.css";
import "./styles/design-system.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ResourcesPage from "./pages/ResourcesPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import ContactPage from "./pages/ContactPage";
import InsuranceInfoPage from "./pages/InsuranceInfoPage";
import AdminLeadsPage from "./pages/AdminLeadsPage";
import StartHerePage from "./pages/StartHerePage";
import ProviderReferralsPage from "./pages/ProviderReferralsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import NoticeOfPrivacyPracticesPage from "./pages/NoticeOfPrivacyPracticesPage";
import TermsPage from "./pages/TermsPage";
import AccessibilityPage from "./pages/AccessibilityPage";
import GoodFaithEstimatePage from "./pages/GoodFaithEstimatePage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AIAssistant, { AIAssistantButton } from "./components/common/AIAssistant";

// Feature flag for AI Assistant (disabled until configured)
const AI_ASSISTANT_ENABLED = process.env.REACT_APP_AI_ASSISTANT_ENABLED === 'true';

// Layout wrapper that conditionally shows Header/Footer
const Layout = ({ children, showAIButton, onOpenAI }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (isAdminRoute) {
    return <>{children}</>;
  }

  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      {AI_ASSISTANT_ENABLED && showAIButton && <AIAssistantButton onClick={onOpenAI} />}
    </>
  );
};

function App() {
  const [showAIAssistant, setShowAIAssistant] = useState(false);
  
  return (
    <div className="App">
      <BrowserRouter>
        <Layout 
          showAIButton={!showAIAssistant} 
          onOpenAI={() => setShowAIAssistant(true)}
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/insurance-info" element={<InsuranceInfoPage />} />
            <Route path="/start-here" element={<StartHerePage />} />
            <Route path="/provider-referrals" element={<ProviderReferralsPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/notice-of-privacy-practices" element={<NoticeOfPrivacyPracticesPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/accessibility" element={<AccessibilityPage />} />
            <Route path="/good-faith-estimate" element={<GoodFaithEstimatePage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/leads" element={<AdminLeadsPage />} />
          </Routes>
        </Layout>
        
        {AI_ASSISTANT_ENABLED && (
          <AIAssistant 
            isOpen={showAIAssistant} 
            onClose={() => setShowAIAssistant(false)} 
          />
        )}
      </BrowserRouter>
    </div>
  );
}

export default App;
